import styled from 'styled-components';
import { Colors } from '../../themes';

// has same size of button
export const Spinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${props =>
    props.size &&
    `
      width: ${props.size.width}px;
      height: ${props.size.height}px;
    `}

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: transparent;
    box-shadow: 0 6px 2px -2px ${props => props.color || Colors.spinner};
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
